import React from 'react';

import { NUMBER_OF_SKELETONS } from '../../constants';
import { BlogPost as BlogPostType } from '../../types';
import { BlogPost } from '../blog-post/blog-post';
import { BlogPostSkeleton } from '../blog-post-skeleton/blog-post-skeleton';

import './blog-overview.css';

type BlogOverviewProps = {
  isLoading: boolean;
  posts: BlogPostType[];
};

export const BlogOverview = ({ isLoading, posts }: BlogOverviewProps) => (
  <section className="blog-overview">
    <div className="blog-overview__content" aria-live="polite">
      {posts.map((post, i) => (
        <BlogPost key={`blog-post-${i}`} post={post} />
      ))}
      {isLoading && (
        <>
          <span className="visibility--screen-reader">
            Loading blog posts...
          </span>
          {[...Array(NUMBER_OF_SKELETONS)].map((_, i) => (
            <BlogPostSkeleton key={`blog-post-skeleton-${i}`} />
          ))}
        </>
      )}
    </div>
  </section>
);
